import { create } from "zustand";
import type { StateCreator } from "zustand";
import { persist } from "zustand/middleware";

import { AuthUserDTORole } from "@/common/api";
import { LocalStorageKey } from "@/common/model";

interface AuthState {
  id: string | null;
  role: AuthUserDTORole | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
}

interface AuthActions {
  saveAuth: (data: {
    id: string;
    role: AuthUserDTORole;
    accessToken: string;
    refreshToken?: string;
  }) => void;
  clearAuth: () => void;
}

type AuthStore = AuthState & AuthActions;

const createAuthStore: StateCreator<AuthStore> = (set) => ({
  id: null,
  role: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  saveAuth: (data) => set({ ...data, isAuthenticated: true }),
  clearAuth: () =>
    set({
      id: null,
      role: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
    }),
});

export const useAuthStore = create<AuthStore>()(
  persist(createAuthStore, {
    name: LocalStorageKey.Auth,
  }),
);
